import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Miten Boostio toimii?',
      answer: 'Boostio lähettää automaattisesti palautekyselyt asiakkaillesi sähköpostilla. Tyytyväiset asiakkaat ohjataan jättämään arvostelu Google-profiiliisi, kun taas negatiivinen palaute ohjataan suoraan sinulle käsiteltäväksi.'
    },
    {
      question: 'Kuinka nopeasti näen tuloksia?',
      answer: 'Useimmat asiakkaamme näkevät ensimmäiset uudet arvostelut jo ensimmäisen viikon aikana. Keskimäärin asiakkaamme saavat 15-30 uutta arvostelua ensimmäisen kuukauden aikana.'
    },
    {
      question: 'Onko palvelu Googlen sääntöjen mukainen?',
      answer: 'Kyllä, Boostio noudattaa täysin Googlen ohjeita. Emme koskaan maksa arvosteluista tai kannusta vain positiivisiin arvosteluihin. Lähetämme aidon palautekyselyn kaikille asiakkaille.'
    },
    {
      question: 'Mitä tapahtuu negatiiviselle palautteelle?',
      answer: 'Negatiivinen palaute ohjataan suoraan sinulle käsiteltäväksi, ei julkisesti Googleen. Näin voit ratkaista ongelmat ennen kuin ne vaikuttavat julkiseen arvosteluprofiiliisi.'
    },
    {
      question: 'Voinko perua milloin tahansa?',
      answer: 'Kaikki paketit sisältävät 14 päivän ilmaisen kokeilun, jonka jälkeen palvelu on 12 kk määräajalla.'
    }
  ];

  return (
    <section id="faq" className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#3B82F6]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#1E3A8A]/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-4xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-12 md:mb-16 animate-[fadeInUp_0.8s_ease-out]">
          <div className="inline-block bg-gradient-to-r from-[#3B82F6] to-[#1E3A8A] text-white px-5 py-2 rounded-full text-sm font-semibold mb-4 shadow-lg">
            Usein kysytyt kysymykset
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 font-inter">
            Vastauksia kysymyksiisi
          </h2>
          <p className="text-lg md:text-xl text-gray-600">
            Etkö löytänyt vastausta? Ota yhteyttä, autamme mielellämme!
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, idx) => (
            <div 
              key={idx} 
              className="bg-white rounded-xl md:rounded-[1.5rem] shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden animate-[fadeInUp_0.8s_ease-out]"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full px-5 py-4 md:px-8 md:py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-300 cursor-pointer group"
              >
                <h3 className="text-base md:text-lg font-bold text-gray-900 pr-4 md:pr-8 group-hover:text-[#1E3A8A] transition-colors duration-300">
                  {faq.question}
                </h3>
                <div className={`w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-gradient-to-br from-[#3B82F6] to-[#1E3A8A] text-white flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''} group-hover:scale-110`}>
                  <i className="ri-arrow-down-s-line text-xl md:text-2xl"></i>
                </div>
              </button>
              
              <div 
                className={`transition-all duration-500 ease-in-out ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4 md:px-8 md:pb-6 text-gray-600 leading-relaxed text-sm md:text-base border-t border-gray-100 pt-4 md:pt-6">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 md:mt-16 text-center animate-[fadeInUp_0.8s_ease-out_0.8s_both]">
          <div className="bg-gradient-to-r from-[#1E3A8A] to-[#3B82F6] rounded-xl md:rounded-2xl p-6 md:p-8 text-white shadow-2xl hover:shadow-[0_25px_50px_-12px_rgba(30,58,138,0.5)] transition-all duration-500">
            <h3 className="text-xl md:text-2xl font-bold mb-3">Tarvitsetko lisää tietoa?</h3>
            <p className="text-white/90 mb-6 text-base md:text-lg">
              Tiimimme on valmis vastaamaan kaikkiin kysymyksiisi
            </p>
            <a 
              href="mailto:info@boostio.fi" 
              className="inline-flex items-center gap-2 bg-white text-[#1E3A8A] px-6 py-3 md:px-8 md:py-4 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 cursor-pointer shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              <i className="ri-mail-line text-lg md:text-xl"></i>
              Ota yhteyttä
            </a>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
}